<mnc-shared-services></mnc-shared-services>

@if (!isIframe && permissionsInitialized) {
  <router-outlet />
}

<p-toast key="httpActionKey" position="bottom-left"></p-toast>
<p-confirmDialog
  #cd
  key="generalConfirmation"
  header="Confirmation"
  appendTo="body"
  rejectButtonStyleClass="p-button-info"
  rejectLabel="No"
  acceptLabel="Yes">
  <ng-template #message let-message>
    <span [innerHTML]="message.message"></span>
  </ng-template>
</p-confirmDialog>
